import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["textContent"]

interface Props {
  messagesCount: number;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'MessageCount',
  props: {
    messagesCount: {}
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: "size-4.5 rounded-xs bg-red-500 text-white text-xs inline-flex items-center justify-center",
    textContent: _toDisplayString(props.messagesCount)
  }, null, 8 /* PROPS */, _hoisted_1))
}
}

})